export default {
    namespaced: true,
    state: {
        marketListPage: 0,
        selling: [],
        soldItems: [],
        marketList: [],
        //marketListCurId: 0,
        nameFilter: "",
        sellerFilter: "",
        typeFilter: "",
        orderBy: ""
    },
    getters: {
        nameFilter(state) {
            return state.nameFilter;
        },
        sellerFilter(state) {
            return state.sellerFilter;
        },
        orderBy(state) {
            return state.orderBy;
        },        
        typeFilter(state) {
            return state.typeFilter;
        },
        soldItems(state){
            return state.soldItems;
        },
        selling(state) {
            return state.selling;
        },
        marketList(state) {
            return state.marketList;
        },
        // marketListCurId(state) {
        //     return state.marketListCurId;
        // },
        marketListPage(state) {
            return state.marketListPage;
        }
    },
    mutations: {
        loadSellingList(state, data) {
            this.getters.socket.emit("get_market_selling", (data) => {
                state.selling = data.selling;
                state.soldItems = data.soldItems;
            })
            
        },
        setMarketList(state, data) {
            if (data.task !== "MORE")
                state.marketList = data.items;
            else {
                state.marketList.push(...data.items);
                //setTimeout(function () {
                //document.getElementById("only-chat-holder").scrollTop = document.getElementById("only-chat-holder").scrollHeight;
                //}, 10);
            }
            if (data.items.length > 0) {
                state.marketListPage++;
                //state.marketListCurId = data.items[data.items.length - 1].end_time;
            }
        },
        itemSold(state, data) {
            for (let item of state.marketList) {
                if (item.id == data.id)
                    item.status = "SOLD";
            }
            for (let item of state.selling) {
                if (item.id == data.id)
                    item.status = "SOLD";
            }
        },
        updateValue(state, data) {
            state[data[0]] = data[1];
        }
    },
    actions: {
        loadSellingList({ commit }, data) {
            commit('loadSellingList');
        },
        loadMarketList({ commit, getters }, data) {
            return new Promise((approve, reject) => {
                try{
                    //let marketListCurId = getters.marketListCurId;
                    let marketListPage = getters.marketListPage;
                    let task = "";
                    if (!data || !data.task || data.task != "MORE") {
                        task = "NEW";
                        commit('updateValue', ["nameFilter", typeof data !== "undefined" && data.nameFilter ? data.nameFilter : ""]);
                        commit('updateValue', ["typeFilter", typeof data !== "undefined" && data.typeFilter ? data.typeFilter : ""]);
                        commit('updateValue', ["sellerFilter", typeof data !== "undefined" && data.sellerFilter ? data.sellerFilter : ""]);
                        commit('updateValue', ["orderBy", typeof data !== "undefined" && data.orderBy ? data.orderBy : ""]);
                        commit('updateValue', ["marketListPage", 0]);
                        //marketListCurId = 0; // Old method, can be removed
                        marketListPage = 0;
                    } else {
                        task = data.task
                    }

                    this.getters.socket.emit("get_market_buying", {
                        //marketListCurId: marketListCurId,
                        marketListPage: marketListPage,
                        nameFilter: getters.nameFilter,
                        typeFilter: getters.typeFilter,
                        sellerFilter: getters.sellerFilter,
                        orderBy: getters.orderBy
                    }, (res) => {
                            if (typeof res !== "undefined" && res && res.items) {
                                commit('setMarketList', {
                                    items: res.items,
                                    task: task
                                });
                                approve(res.items.length);
                            } else {
                                console.log("Market returned error")
                                reject();
                            }
                    })
                } catch(e){
                    console.error(e)
                }
            });

            
        },
        itemSold({ commit }, data) {
            commit('itemSold', data);
        },
        cancelItem({ commit }, item) {
            return new Promise((approve, reject) => {
                this.getters.socket.emit("cancel_market_item", { id: item.id }, (affectedRows) => {
                    approve(affectedRows);
                });
            });
        }
    }
};